@if (!isLoading) {
  <div class="container">
    <div class="section">
      <span>{{ 'REGISTRATI' | translate }}</span>
    </div>
    <form [formGroup]="signupForm" class="serif">
      <div class="first-block">
        <mat-form-field appearance="outline">
          <mat-label>{{'NOME' | translate}}</mat-label>
          <input matInput type="text" formControlName="name"/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'COGNOME' | translate}}</mat-label>
          <input matInput type="text" formControlName="surname"/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'EMAIL' | translate}}</mat-label>
          <input matInput type="text" formControlName="email"/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'NUMERO_DI_TELEFONO' | translate}}</mat-label>
          <input matInput type="text" formControlName="phone"/>
        </mat-form-field>
      </div>
      <div class="second-block">
        <mat-form-field appearance="outline">
          <mat-label>{{'PASSWORD' | translate}}</mat-label>
          <input matInput type="password" formControlName="password"/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'RIPETI_PASSWORD' | translate}}</mat-label>
          <input matInput type="password" formControlName="confirmPassword"/>
          @if (signupForm?.get('confirmPassword')?.hasError('notSamePassword')) {
            <mat-error
            >{{ 'PASSWORD_NON_CORRISPONDONO' | translate}}</mat-error>
          }
        </mat-form-field>
        <app-multi-select
          [multiSelectionValues]="selectionList.jobTitle"
          [required]="true"
          (ngModelChange)="updateCompanyValidators()"
          formControlName="jobTitleId"
        ></app-multi-select>
      </div>

      @if (showCompany) {
        <div class="mono-block"
          >
          <mat-form-field appearance="outline">
            <mat-label>{{'NOME_AZIENDA' | translate}}</mat-label>
            <input matInput type="text" formControlName="company" required/>
          </mat-form-field>
        </div>
      }
      <div class="mono-block">
        <mat-form-field appearance="outline" class="country-select">
          <mat-label>{{'NAZIONE' | translate}}</mat-label>
          <mat-select formControlName="countryId" required>
            @for (country of selectionList?.country; track country) {
              <mat-option
              [value]="country?.id">{{country?.description}}</mat-option>
            }
          </mat-select>
<!--          <button mat-icon-button matSuffix tabindex="-1" disableRipple>-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">-->
<!--              <path d="M10.2278 4.88608L6.11392 9L2 4.88608" stroke="black"/>-->
<!--            </svg>-->
<!--          </button>-->
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'CITTA' | translate}}</mat-label>
          <input matInput type="text" formControlName="city" required/>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{'CAP' | translate}}</mat-label>
          <input matInput type="text" formControlName="zip" required/>
        </mat-form-field>
      </div>
      <div class="terms-container">
        <div class="pb-2">
          <mat-checkbox class="round-checkbox" formControlName="subscriptionMailchimp" disableRipple>
            <div class="policy_description">{{'SOTTOSCRIVI_NEWSLETTER_DESCRIPTION' | translate}}</div>
          </mat-checkbox>
        </div>
        <div formArrayName="policy">
          @for (policyForm of policyFormArray?.controls; track policyForm; let i = $index) {
            <div [formGroupName]="i" class="form">
              <mat-checkbox class="round-checkbox" formControlName="value" disableRipple>
                <div class="policy_description" [innerHTML]="policyForm?.value?.description"></div>
              </mat-checkbox>
            </div>
          }
        </div>
      </div>
      <div class="buttons-block">
        <button class="button-confirm"
          [ngClass]="{'button-confirm-base-disabled': !isValidForm() || isLoading}"
          (click)="submitSignupForm()" [disabled]="!isValidForm() || isLoading"
          mat-button>
          <span class="confirm-label">{{'CONFERMA_UTENTE' | translate}}</span>
        </button>
      </div>
    </form>
  </div>
} @else {
  <app-visionnaire-loader class="ipe:w-full ipe:h-full" />
}

<!--<ng-template #loading>-->
<!--  <app-visionnaire-loader class="ipe:w-full" />-->
<!--</ng-template>-->

<ng-template #registrationSuccessTemplate>

  <div class="redirect-container">

    <h1 class="redirect-title">
      {{ 'REGISTRAZIONE_OK' | translate }}
    </h1>

    <br/>

    <p class="redirect-activation">{{ 'LINK_ATTIVAZIONE_USER' | translate }}</p>

    <br/>

    <p class="redirect-message">
      {{ 'VERRAI_REINDIRIZZATO_GENERICO' | translate: {countDown: countDown} }}
    </p>

  </div>
</ng-template>

<app-footer></app-footer>
